export function pageFileName(pageIndex: number): string {
  return `page-${String(pageIndex).padStart(3, "0")}.jpg`;
}

export function indexFromName(name: string): number {
  const m = /page-(\d+)\.jpg$/.exec(name);
  if (!m) throw new Error(`bad page name ${name}`);
  return Number(m[1]);
}
